import { render, staticRenderFns } from "./S3ConfigurationDetails.vue?vue&type=template&id=b287818e&"
import script from "./S3ConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./S3ConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b287818e')) {
      api.createRecord('b287818e', component.options)
    } else {
      api.reload('b287818e', component.options)
    }
    module.hot.accept("./S3ConfigurationDetails.vue?vue&type=template&id=b287818e&", function () {
      api.rerender('b287818e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/S3ConfigurationDetails.vue"
export default component.exports